import { Gauge, ListChecks } from 'lucide-react';

import type { JudgeKindIconProps } from './JudgeKindIcon.types';

const DEFAULT_CLASS = 'h-[14px] w-[14px]';

export const JudgeKindIcon = ({ kind, className = DEFAULT_CLASS }: JudgeKindIconProps) =>
	kind === 'rubric' ? <Gauge className={className} /> : <ListChecks className={className} />;
